import { Check, ChevronsUpDown } from 'lucide-react'
import { useWorkspace } from '@/providers/workspace-provider'
import { LABELS } from '@/lib/constants'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export function WorkspaceSwitcher() {
  const { memberships, currentWorkspace, setCurrentWorkspace, role } = useWorkspace()

  if (!currentWorkspace) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="glass" className="h-11 w-full justify-between px-3 text-left">
          <span className="flex flex-col overflow-hidden">
            <span className="truncate text-sm font-semibold">{currentWorkspace.name}</span>
            {role && <span className="text-xs text-muted-foreground">{LABELS.role[role]}</span>}
          </span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuLabel>Workspaces</DropdownMenuLabel>
        {memberships.map((m) => (
          <DropdownMenuItem
            key={m.workspace.id}
            onClick={() => setCurrentWorkspace(m.workspace.id)}
          >
            <Check
              className={cn(
                'h-4 w-4',
                m.workspace.id === currentWorkspace.id ? 'opacity-100' : 'opacity-0',
              )}
            />
            <span className="truncate">{m.workspace.name}</span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem disabled className="text-xs text-muted-foreground">
          Trocar de workspace muda todo o conteúdo exibido.
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
